import { AbstractEnum } from "./abstract-enum";

export class InvestorTypeEnum extends AbstractEnum {
  public static INDIVIDUAL = 1 as const;
  public static INSTITUTION = 2 as const;
  public static CORPORATE = 3 as const;

  public static choices = {
    [InvestorTypeEnum.INDIVIDUAL]: "Individual",
    [InvestorTypeEnum.INSTITUTION]: "Institutional",
    [InvestorTypeEnum.CORPORATE]: "Corporate",
  };
}

export type InvestorTypeEnumType = keyof typeof InvestorTypeEnum.choices;
